export default __webpack_public_path__ + "static/media/question-white-active.61f6ea07.svg";